import { useMutation } from 'react-query';

import { setCheckerConfigParams as mutationFn } from 'api/endPoints/setCheckerConfigParams';

export const useMutationSetCheckerConfigParams = () => {
    return useMutation<any, QueryError, ConfigParams>('setCheckerConfigParams', (params) => mutationFn(params));
};

export interface ConfigParams {
    configId: number;
    lowerLimit: number;
    upperLimit: number;
    metaDataId: number;
}
